import $ from 'jquery';
import Filterable from '../components/filterable';

class PressArchive {
    constructor() {
        this.initialize();
    }

    initialize() {
        Filterable.init();
    }

    static init() {
        if ($('.press-archive').length > 0) {
            new PressArchive();
        }
    }
}

export default PressArchive;
